export const doesIncludes = (value, searchValue) => {
  return value?.toLowerCase().includes(searchValue.toLowerCase())
}
